// =====================================================================
// SEGUNDO FACTOR DEL PERSONAL · ESTABILIDAD Parte D · D6
// =====================================================================
// Ajuste de EMPRESA (va en «Administración»): si además de dueño y
// administradores, también el personal debe configurar el segundo factor.
// Nace apagado. Encenderlo no deja a nadie fuera de golpe: a cada persona
// se le lleva a configurarlo la próxima vez que entra.
import { useEffect, useState } from 'react';
import { Users, Loader2 } from 'lucide-react';
import { api } from '../api';
import Ayuda from '../ui/Ayuda';
import ModalConfirmar from '../ui/ModalConfirmar';

export default function SegundoFactorDelPersonal() {
  const [exigir, setExigir] = useState(null);
  const [pidiendo, setPidiendo] = useState(null);
  const [msg, setMsg] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/seguridad/empresa/exigir-2fa-empleados')
      .then((r) => setExigir(r.exigir))
      .catch((e) => setError(e.message || 'No se pudo leer el ajuste. Revisa la conexión y vuelve a abrir la pantalla.'));
  }, []);

  async function guardar(valor) {
    const r = await api.put('/seguridad/empresa/exigir-2fa-empleados', { exigir: valor });
    setExigir(r.exigir);
    setMsg(r.mensaje);
    setPidiendo(null);
  }

  return (
    <div className="space-y-4 max-w-2xl">
      <div className="flex items-start gap-2">
        <Users className="h-6 w-6 text-[var(--color-marca)] shrink-0" aria-hidden="true" />
        <div>
          <h1 className="text-lg font-semibold text-gray-900">Segundo factor del personal</h1>
          <p className="text-sm text-gray-600">Decide si tu personal también debe usar un código del teléfono al entrar.</p>
        </div>
      </div>
      <Ayuda id="seguridad.personal_2fa.pantalla" />

      {exigir === null && !error && (
        <p className="flex items-center gap-2 text-sm text-gray-500"><Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> Cargando…</p>
      )}
      {exigir !== null && (
        <section className="bg-white border border-gray-200 rounded-xl p-4 space-y-3">
          <p className="text-sm">
            Hoy: <span className={`font-semibold ${exigir ? 'text-green-800' : 'text-gray-800'}`}>
              {exigir ? 'obligatorio para todo el personal' : 'opcional para el personal'}
            </span>. Dueño y administradores lo necesitan siempre.
          </p>
          <button type="button" onClick={() => setPidiendo(!exigir)}
                  className="min-h-11 rounded-lg bg-[var(--color-marca)] px-4 py-2 text-sm font-semibold text-white">
            {exigir ? 'Volverlo opcional' : 'Volverlo obligatorio'}
          </button>
          <Ayuda id="seguridad.personal_2fa.interruptor" />
        </section>
      )}
      {msg && <p role="status" className="text-sm border rounded-lg p-2.5 text-green-800 bg-green-50 border-green-200">{msg}</p>}
      {error && <p role="alert" className="text-sm border rounded-lg p-2.5 text-red-700 bg-red-50 border-red-200">{error}</p>}
      {pidiendo !== null && (
        <ModalConfirmar
          titulo={pidiendo ? 'Volver obligatorio el segundo factor' : 'Volver opcional el segundo factor'}
          descripcion={pidiendo
            ? 'Cada persona verá el asistente para configurarlo la próxima vez que entre, y podrá seguir trabajando mientras.'
            : 'Tu personal dejará de ver el asistente al entrar. Quien ya lo configuró lo sigue usando.'}
          etiquetaConfirmar={pidiendo ? 'Volverlo obligatorio' : 'Volverlo opcional'}
          onConfirmar={() => guardar(pidiendo)}
          onCerrar={() => setPidiendo(null)}
        />
      )}
    </div>
  );
}
